import { render, staticRenderFns } from "./SmtpMailDriver.vue?vue&type=template&id=42829d0f&"
import script from "./SmtpMailDriver.vue?vue&type=script&lang=js&"
export * from "./SmtpMailDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42829d0f')) {
      api.createRecord('42829d0f', component.options)
    } else {
      api.reload('42829d0f', component.options)
    }
    module.hot.accept("./SmtpMailDriver.vue?vue&type=template&id=42829d0f&", function () {
      api.rerender('42829d0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/mail-driver/SmtpMailDriver.vue"
export default component.exports